import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  userAction: {
    backgroundColor: '#F1F1F1',
    color: 'white',
    borderRadius: 28,
    minHeight: 58,
    padding: theme.spacing(1, 2),
    display: 'inline-flex',
    flexDirection: 'column',
    '&:not($userActionMine)': {
      marginRight: 'auto',
      borderBottomLeftRadius: 0
    }
  },
  userActionMine: {
    marginLeft: 'auto',
    borderBottomRightRadius: 0
  },
  bidAction: {
    backgroundColor: theme.palette.royal.main
  },
  donateAction: {
    backgroundColor: theme.palette.primary.main
  },
  purchaseAction: {
    backgroundColor: theme.palette.pink.main
  },
  userName: {
    fontSize: 12,
    fontWeight: 700,
    lineHeight: '1rem',
    marginBottom: 6
  },
  actionAmount: {
    fontSize: 19,
    fontWeight: 700,
    lineHeight: '1rem'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/ChatList/UserAction/styles.js